<template>
    <div class="deputados-eleitos">
		<h3>Deputados eleitos</h3>
		<p v-if="mandatos"><span>{{mandatos.atribuidos || 0}}</span> de {{mandatos.total || 230}}</p>
        <graficos-parlamento :data="resultados" :order="assentos"/>
    </div>
</template>

<script>
import { assentos } from '@/widgets/eleicoes/partidos'

export default {
    data: () => ({
        assentos
    }),
    computed: {
        mandatos() {
            return !this.$state.globais ? null : this.$state.globais.mandatos;
        },
        resultados() {
            return !this.$state.globais || !this.$state.globais.legislativas ? null : this.$state.globais.legislativas.resultados;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';
.deputados-eleitos {
    width: 100%;
    max-width: 460px;
    margin: 0 auto 2rem;
	text-align: center;
	
    p {
        color: var(--base-medium-color);
        span {
            color: var(--base-link);
        }
    }
}
</style>